module.exports = [
  
  {
    "id": "ba4fa232-4d85-4ccb-97e2-65f9daf3e357",
    "combo-array": [
      "3",
      "4",
      "3",
      "2"
    ],
    "boxer": "common",
    "combo-name": "Lead Hook, Rear Hook, Lead Hook, Cross"
  },
  {
    "id": "901d6610-14f2-45e4-8781-aa5cbd057a2b",
    "combo-array": [
      "9",
      "4"
    ],
    "boxer": "common",
    "combo-name": "Lead Body Hook, Rear Hook"
  },
  {
    "id": "af9993ac-2bb4-454d-b2e5-9dc98ee32e01",
    "combo-array": [
      "3",
      "4"
    ],
    "boxer": "common",
    "combo-name": "Lead Hook, Rear Hook"
  },
  {
    "id": "7b9fb93c-90bd-40aa-9f6c-b7a2e8076ce4",
    "combo-array": [
      "1",
      "2",
      "1"
    ],
    "boxer": "common",
    "combo-name": "Jab Cross Jab"
  },
  {
    "id": "5e7bc421-e9e0-4161-a3d9-e9109300aa02",
    "combo-array": [
      "1",
      "1",
      "2"
    ],
    "boxer": "common",
    "combo-name": "Double Jab Cross"
  },
  {
    "id": "08e77f4e-ead5-4658-92ae-f48f76729ef7",
    "combo-array": [
      "5",
      "6",
      "3"
    ],
    "boxer": "common",
    "combo-name": "Lead Uppercut, Rear Uppercut, Lead Hook"
  },
  {
    "id": "1db3ff1b-2b4e-48c9-bf0b-a01c8917e2cd",
    "combo-array": [
      "1",
      "2",
      "11"
    ],
    "boxer": "common",
    "combo-name": "Jab, Cross, Lead Shovel Hook"
  },
  {
    "id": "b7d07b0b-eb98-46b9-a6ee-af3e904bd74c",
    "combo-array": [
      "5",
      "2"
    ],
    "boxer": "common",
    "combo-name": "Lead Uppercut, Cross"
  },
  {
    "id": "86d7916c-2546-4369-9ed9-7919768a1bdc",
    "combo-array": [
      "6",
      "3"
    ],
    "boxer": "common",
    "combo-name": "Rear Uppercut, Lead Hook"
  },
  {
    "id": "ef3c41e9-132d-4e42-97ea-a414174000ba",
    "combo-array": [
      "2",
      "3",
      "2"
    ],
    "boxer": "common",
    "combo-name": "Cross Lead Hook Cross"
  },
  {
    "id": "f616008f-78dc-4473-a95c-fc01ee7e97c0",
    "combo-array": [
      "2",
      "3"
    ],
    "boxer": "common",
    "combo-name": "Cross Lead Hook"
  },
  {
    "id": "6d18bbc2-00b7-44f3-a0de-2957788b9569",
    "combo-array": [
      "1",
      "4"
    ],
    "boxer": "common",
    "combo-name": "Jab Rear Hook"
  },
  {
    "id": "d3f4f49f-188f-45f5-8030-279bda0bad74",
    "combo-array": [
      "1",
      "2",
      "3"
    ],
    "boxer": "common",
    "combo-name": "Jab Cross Lead Hook"
  },
  {
    "id": "01147efb-2d4b-44c1-92bc-0b19ccda3c3d",
    "combo-array": [
      "1",
      "2"
    ],
    "boxer": "common",
    "combo-name": "Jab Cross"
  },
  {
    "id": "d8f25523-8399-4609-ae6c-cf949d3aa06d",
    "combo-array": [
      "7",
      "1",
      "2o",
      "3"
    ],
    "boxer": "3",
    "combo-name": ""
  },
  {
    "id": "8871a5e1-171a-4483-a0e0-e9e8cc9a2e19",
    "combo-array": [
      "DL",
      "3",
      "2o"
    ],
    "boxer": "3",
    "combo-name": ""
  },
  {
    "id": "8eb2a52b-022f-459a-ba7a-4b79725d3fb0",
    "combo-array": [
      "1",
      "5",
      "2o",
      "3"
    ],
    "boxer": "3",
    "combo-name": ""
  },
  {
    "id": "6d549438-7b54-407d-9d9c-5288e41ddc43",
    "combo-array": [
      "1",
      "SL",
      "11",
      "2o"
    ],
    "boxer": "3",
    "combo-name": ""
  },
  {
    "id": "385d8f19-72aa-49b7-8fa5-bd18739d8f13",
    "combo-array": [
      "SR",
      "6",
      "5",
      "3",
      "P",
      "2",
      "3"
    ],
    "boxer": "3",
    "combo-name": ""
  },
  {
    "id": "6d67ff0a-850c-45bc-a0dd-0a0752352a57",
    "combo-array": [
      "1",
      "2",
      "1o",
      "6"
    ],
    "boxer": "3",
    "combo-name": ""
  },
  {
    "id": "f97a8587-9d00-4937-ab6c-b7779b090cf3",
    "combo-array": [
      "4",
      "3",
      "DL",
      "3"
    ],
    "boxer": "3",
    "combo-name": ""
  },
  {
    "id": "4d35dccb-c9ad-4770-8adf-915ded56037f",
    "combo-array": [
      "6",
      "11",
      "5"
    ],
    "boxer": "3",
    "combo-name": ""
  },
  {
    "id": "aacefcd0-be50-428c-8154-50c41194ed12",
    "combo-array": [
      "1",
      "9",
      "4"
    ],
    "boxer": "3",
    "combo-name": ""
  },
  {
    "id": "46c146f0-d817-4f83-ba06-49bdadd1ca78",
    "combo-array": [
      "1",
      "2",
      "3",
      "6",
      "11"
    ],
    "boxer": "4",
    "combo-name": ""
  },
  {
    "id": "6a17fc99-8e7c-4f33-9466-555e155ddde7",
    "combo-array": [
      "BL",
      "SR",
      "6",
      "11"
    ],
    "boxer": "4",
    "combo-name": ""
  },
  {
    "id": "4f443b2c-57a3-4da5-bf48-7596d38ec16b",
    "combo-array": [
      "BL",
      "5",
      "6",
      "11",
      "DR",
      "2",
      "3"
    ],
    "boxer": "4",
    "combo-name": ""
  },
  {
    "id": "96bc20f3-629c-463e-8c5e-577e2621ec9a",
    "combo-array": [
      "DL",
      "6",
      "5"
    ],
    "boxer": "4",
    "combo-name": ""
  },
  {
    "id": "0f1c4398-b1f8-44cb-9bf6-203ae733f9fe",
    "combo-array": [
      "1",
      "2",
      "SL",
      "2",
      "3",
      "SR",
      "DL",
      "2",
      "3"
    ],
    "boxer": "4",
    "combo-name": ""
  },
  {
    "id": "19572058-ecdf-4b1f-b8a0-b73b8ad232e4",
    "combo-array": [
      "BL",
      "3",
      "6",
      "3",
      "SR",
      "11",
      "3",
      "2",
      "3"
    ],
    "boxer": "4",
    "combo-name": ""
  },
  {
    "id": "6da5e7e8-8a58-44a0-8b60-65b2e7d18937",
    "combo-array": [
      "6",
      "5",
      "6",
      "5",
      "6",
      "3"
    ],
    "boxer": "4",
    "combo-name": ""
  },
  {
    "id": "75cb8e75-a272-463c-83ed-f6f95ca42da6",
    "combo-array": [
      "1",
      "2",
      "1",
      "2",
      "3",
      "SL"
    ],
    "boxer": "4",
    "combo-name": ""
  },
  {
    "id": "8cd88572-fc26-4926-803e-c6548465cad4",
    "combo-array": [
      "6",
      "5",
      "6",
      "11",
      "DL",
      "6",
      "11"
    ],
    "boxer": "4",
    "combo-name": ""
  },
  {
    "id": "fab58139-f8e4-409e-a9ec-cb60a822f186",
    "combo-array": [
      "1",
      "1",
      "SR",
      "2",
      "3"
    ],
    "boxer": "5",
    "combo-name": ""
  },
  {
    "id": "6ccd7a9f-1dd8-4323-8d29-dad5376deeb3",
    "combo-array": [
      "1",
      "SL",
      "3",
      "2",
      "DR"
    ],
    "boxer": "5",
    "combo-name": ""
  },
  {
    "id": "220b1c32-3583-46bd-a21f-b99dfdedbc10",
    "combo-array": [
      "1",
      "2",
      "3",
      "SL",
      "3",
      "DL",
      "3"
    ],
    "boxer": "5",
    "combo-name": ""
  },
  {
    "id": "33f4e1d7-6b36-4030-8dcf-972f372a5f7a",
    "combo-array": [
      "2",
      "3",
      "SL",
      "11",
      "3"
    ],
    "boxer": "5",
    "combo-name": ""
  },
  {
    "id": "7598098b-4fa8-4f72-a392-372c2136d206",
    "combo-array": [
      "1",
      "2",
      "3",
      "SL",
      "11",
      "11",
      "DR",
      "2"
    ],
    "boxer": "5",
    "combo-name": ""
  },
  {
    "id": "d3ba6a6f-7e7c-470e-9f37-02a4d78c91a4",
    "combo-array": [
      "10",
      "6",
      "3",
      "DR",
      "3",
      "2"
    ],
    "boxer": "5",
    "combo-name": ""
  },
  {
    "id": "1d9876d0-05b6-47d9-ad79-6d1c489bf5a4",
    "combo-array": [
      "1",
      "2",
      "3",
      "SL",
      "3",
      "2"
    ],
    "boxer": "5",
    "combo-name": ""
  },
  {
    "id": "e73caf82-9527-48ef-a303-15cd2c92c632",
    "combo-array": [
      "1",
      "10",
      "3",
      "DL",
      "3"
    ],
    "boxer": "5",
    "combo-name": ""
  },
  {
    "id": "b3d2b8e2-f778-49c4-a2f9-407b3a85546b",
    "combo-array": [
      "1",
      "2",
      "3",
      "SL",
      "11",
      "5",
      "2o",
      "SL",
      "2",
      "3"
    ],
    "boxer": "5",
    "combo-name": ""
  },
  {
    "id": "b3d2b8e2-f778-f23fg407b3a85546b",
    "combo-array": [
      "1",
      "1",
      "8"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "b3d2b8e2-f778-49c4-a2f9-4wegqw2546b",
    "combo-array": [
      "1",
      "2",
      "DL"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "gh6j-f778-49c4-a2f9-407b3a85546b",
    "combo-array": [
      "SL",
      "2o"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "gg3g4h-f778-49c4-a2f9-407b3a85546b",
    "combo-array": [
      "3",
      "2",
      "3"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "5y6ujg-f778-49c4-a2f9-407b3a85546b",
    "combo-array": [
      "3",
      "2",
      "5",
      "6",
      "5",
      "6",
      "DL"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "111113-f778-49c4-a2f9-407b3a85546b",
    "combo-array": [
      "1",
      "2",
      "DR"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "67789-f778-49c4-a2f9-407b3a85546b",
    "combo-array": [
      "2",
      "3",
      "DL"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "67789-f778-49c4-a2f9-407b3a85546b",
    "combo-array": [
      "1",
      "2",
      "3",
      "8",
      "DL",
      "2"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "67789-f778-49c4-4t4yt4-407b3a85546b",
    "combo-array": [
      "1",
      "8",
      "8"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "67789-f778-49c4-4t4yt4-407b3a85546b",
    "combo-array": [
      "1",
      "2",
      "SR",
      "2"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "67789-f778-49c4-4t4yt4-407b3a85546b",
    "combo-array": [
      "1",
      "2",
      "DR",
      "10",
      "3"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "67789-f778-49c4-4t4yt4-407b3a85546b",
    "combo-array": [
      "1",
      "2o",
      "11"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "67789-f778-49c4-4t4yt4-456322tgt",
    "combo-array": [
      "SL",
      "11",
      "6",
      "3"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "677-f778-49c4-4t4yt4-407b3a85546b",
    "combo-array": [
      "SL",
      "3",
      "DL",
      "3",
      "6"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "67789-f778-49c4-4t4yt4-407b3a85546b",
    "combo-array": [
      "1",
      "2",
      "3",
      "DL",
      "3",
      "2"
    ],
    "boxer": "6",
    "combo-name": ""
  },
  {
    "id": "67789-f778-iugv-4t4yt4-407b3a85546b",
    "combo-array": [
      "BL",
      "2",
      "3",
      "2"
    ],
    "boxer": "7",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-4t4yt4-407b3a85546b",
    "combo-array": [
      "BL",
      "2",
      "3",
      "2",
      "1",
      "1",
      "1"
    ],
    "boxer": "7",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-4t4yt4-407b3a85546b",
    "combo-array": [
      "SR",
      "2",
      "3",
      "2",
      "1",
      "1",
      "1"
    ],
    "boxer": "7",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-4t4yt4-407b3a85546b",
    "combo-array": [
      "2",
      "3",
      "2",
      "DR",
      "2",
      "3",
      "2"
    ],
    "boxer": "7",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-4t4yt4-3g434g34gw",
    "combo-array": [
      "6",
      "3",
      "2",
      "DR",
      "2",
      "3",
      "2"
    ],
    "boxer": "7",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "SR",
      "SL",
      "DR",
      "2",
      "3",
      "2",
      "1",
      "1",
      "1"
    ],
    "boxer": "7",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "6",
      "3",
      "2",
      "DR",
      "2",
      "3",
      "2",
      "BL",
      "2",
      "3",
      "2",
      "SR",
      "2",
      "3",
      "2",
      "SR",
      "SL",
      "DR",
      "2",
      "3",
      "2",
      "P",
      "2",
      "3",
      "2",
      "1",
      "1",
      "1"
    ],
    "boxer": "7",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "1",
      "1",
      "1",
      "6",
      "5"
      
    ],
    "boxer": "8",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "1",
      "P",
      "1",
      "2"
      
    ],
    "boxer": "8",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "DR",
      "DL",
      "1",
      "1"
      
    ],
    "boxer": "8",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "1",
      "1",
      "6",
      "2"
      
    ],
    "boxer": "8",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "1",
      "1",
      "6",
      "4"
      
    ],
    "boxer": "8",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "1",
      "1",
      "SL",
      "5",
      "2o"
      
    ],
    "boxer": "8",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "SL",
      "2",
      "5",
      "2",
      "3",
      "DR"
      
    ],
    "boxer": "8",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "1",
      "SR",
      "3",
      "2"
      
    ],
    "boxer": "8",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "1",
      "DL",
      "2",
      "3",
      "2"
      
    ],
    "boxer": "8",
    "combo-name": ""
  },
  {
    "id": "67789-g4g4-iugv-grgrg-407b3a85546b",
    "combo-array": [
      "1",
      "SR",
      "2o",
      "3"                           
      
    ],
    "boxer": "8",
    "combo-name": ""
  }
  
]